import { gql } from '@apollo/client';

const CREATE_UPDATE_SUPPLIERORDER_STATUS = gql`mutation createUpdateSupplierOrderStatus($input: SupplierOrderStatusInput!) {
	incomingOrders {
		createUpdateSupplierOrderStatus(input: $input) {
			success
			result {
				id
				name
				action
				productionStatus
				color
				actionTrigger
				userMustConfirmAction
			}
		}
	}
}`;

export default CREATE_UPDATE_SUPPLIERORDER_STATUS;
